import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'
import { prepareHoop } from './prepareHoop.js'

// ============================================================================
//  glbHoop — wczytanie modelu kosza z pliku GLB (Draco) i osadzenie w scenie.
//  Zastępuje proceduralny rejestr builderów. Kontrakt jak dawniej, ale
//  ASYNCHRONICZNY: { group, rimCenter, dispose() }. Skala/obrót/pozycja i
//  ukrywane materiały biorą się z hoopDef.transform/hoopDef.hide (katalog).
//  Ścieżki budowane z BASE_URL (Vite), spójnie z loadHoopCatalog.
// ============================================================================

let loader

// Jedna instancja loadera (z dekoderem Draco) na moduł — GLTFLoader cache'uje
// pobrane pliki, więc ponowny wybór tego samego modelu jest tani.
function getLoader() {
  if (loader) return loader
  const base = import.meta.env?.BASE_URL || '/'
  const draco = new DRACOLoader().setDecoderPath(`${base}draco/`)
  loader = new GLTFLoader().setDRACOLoader(draco)
  return loader
}

export async function loadHoop(hoopDef) {
  const base = import.meta.env?.BASE_URL || '/'
  const gltf = await getLoader().loadAsync(`${base}${hoopDef.model}`)
  return prepareHoop(gltf.scene, hoopDef)
}
